<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectField"
    />

    <!-- 사업개요 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업개요</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장주소(소재지)</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.address }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.fieldInfo.address"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.ceo }}</p>
          <ml-input
            v-else
            :readonly="board.readonly"
            v-model="form.fieldInfo.ceo"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업(공사)금액</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.deposit_amount }}
          </p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.fieldInfo.deposit_amount"
            class="w-full flex-1"
          />
        </div>

        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">착공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.start_work_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.start_work_at"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">준공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.be_completed_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.be_completed_at"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">발주자</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.orderer }}</p>
          <ml-input
            v-else
            :readonly="board.readonly"
            v-model="form.fieldInfo.orderer"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">누계 공정율</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.percent }}</p>
          <ml-input
            v-else
            :readonly="board.readonly"
            v-model="form.fieldInfo.percent"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">법정안전관리비</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.legal }}</p>
          <comma-input
            v-else
            :readonly="board.readonly"
            v-model="form.fieldInfo.legal"
            class="w-full flex-1"
          ></comma-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">집행율</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.rate }}</p>
          <ml-input
            v-else
            readonly
            v-model="form.fieldInfo.rate"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 산업안전보건관리비 -->
    <div class="print-container">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 산업안전보건관리비</h5>
        </vs-col>
      </vs-row>

      <table-budget
        v-model="form.budget"
        :usePrint="isPostId"
        :isPrint="isPrint"
        :readonly="board.readonly"
        :header="header"
        @budgetTotal="(data) => (form.budgetTotal = data)"
      />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

import TableBudget from "@/components/table-budget/TableBudget.vue";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    PhotoUploadGridModule,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TableBudget,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.approval.list))];
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    header: {
      deep: true,
      handler(value) {
        this.oldDataSetting();
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        let rate = 0;
        if (
          !!value.fieldInfo.legal &&
          0 < Number(value.fieldInfo.legal) &&
          !!value.budgetTotal &&
          0 < Number(value.budgetTotal.total)
        )
          rate =
            Number(value.budgetTotal.total) / Number(value.fieldInfo.legal);
        value.fieldInfo.rate = rate;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fieldInfo: {
          address: "",
          ceo: "",
          deposit_amount: "",
          start_work_at: "",
          be_completed_at: "",
          orderer: "",
          percent: "",
          legal: "",
          rate: "",
        },
        budgetTotal: {},
        budget: [
          {
            label: "안전·보건관리자 임금 등",
            type: "인건비",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "안전시설비 등",
            type: "시설",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "보호구 등",
            type: "장비",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "안전보건진단비 등",
            type: "안전진단",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "안전보건교육비 등",
            type: "교육행사",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "근로자 건강장해예방비 등",
            type: "건강",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "건설재해예방전문지도기관 기술지도비",
            type: "기술",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "본사 전담조직 근로자 임금 등",
            type: "본사근로자",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
          {
            label: "위험성평가 등에 따른 소요비용",
            type: "기타",
            arcc: false,
            detail: {
              prev: 0,
              now: 0,
              total: 0,
              data: [],
            },
          },
        ],
        photoList: [],
        fileList: [],
      },
    };
  },
  mounted() {
    if (!this.isPostId) this.loadListApproval();
  },
  methods: {
    async loadListApproval() {
      // 내용불러오기
      const projectId = this.projectId;
      const boardSlug = "board-279";
      const page = 1;
      const perPage = 10000;
      const dateTarget = ["created_at"];
      const dateBegin = [`${new Date().getFullYear()}-01-01`];
      const dateEnd = [`${new Date().getFullYear()}-12-31`];

      await this.$store.dispatch("approval/LOAD_POST_ALL", {
        boardSlug,
        projectId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd,
      });

      this.oldDataSetting();
    },

    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.header;
      }
    },

    onSelectField(data) {
      this.form.fieldInfo.address = data.address;
      this.form.fieldInfo.deposit_amount = data.deposit_amount;
      this.form.fieldInfo.start_work_at = data.start_work_at;
      this.form.fieldInfo.be_completed_at = data.be_completed_at;
      this.form.fieldInfo.be_completed_at = data.be_completed_at;
    },

    oldDataSetting() {
      if (this.postList.length > 0) {
        const checkMonth = this.header.month;
        const budget = this.form.budget;

        // 초기화
        for (let i = 0; i < budget.length; i++) {
          budget[i].detail.prev = 0;
        }

        for (const post of this.postList) {
          if (post.document_status.code === "approved") {
            const head = this.getHeader(post);
            const content = this.getContent(post);

            // 이번달 이전의 데이터 찾기
            if (Number(head.month) < Number(checkMonth)) {
              if (content.budget && content.budget.length > 0) {
                for (let i = 0; i < content.budget.length; i++) {
                  const iBudget = content.budget[i];
                  budget[i].detail.prev += iBudget.detail.now;
                }
              }
            }
          }
        }

        this.form.budget = budget;
      } else {
        // 데이터가 없을 경우 누적 사용량 0원 처리
        for (const data of this.form.budget) {
          data.detail.prev = 0;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
